module.exports = __webpack_public_path__ + "static/media/hover.edd79ea7.mp4";